import React from 'react';

import Wrapper from './Layout/Wrapper';
import { Icon } from '../Elements/Icon';

import TranslatedText from './TranslatedText';

const Labels = ({ items }) => {
    if (!items || items.length === 0 ) {
        return null;
    }

    return (
        <Wrapper>
            <ul className="labels">
                { items.map((item, idx) => (
                    <Label key={ idx } label={ item.label } icon={ item.icon } />
                )) }
            </ul>
        </Wrapper>
    );
}

export default Labels;

const Label = ({ label, icon }) => {
    return (
        <>
            <li className="labels__item">
                <Icon name={icon} withInlineStyle={ false } additionalClasses={`labels__icon labels__icon--${icon}`} />
                <span className="labels__text"><TranslatedText item={ label } /></span>
            </li>
            <li className="labels__divider" aria-hidden="true"></li>
        </>
    );
}